import * as yup from 'yup'

export const loginSheme = yup.object().shape({
    email: yup.string().email("please enter a valid email").required("Required"),
    password: yup
        .string()
        // .min(8, 'Password must be at least 8 characters long')
        // .matches(/[A-Z]/, 'Password must contain at least one uppercase letter') // At least one uppercase
        // .matches(/[0-9]/, 'Password must contain at least one number') // At least one number
        // .matches(/[@$!%*?&]/, 'Password must contain at least one special character') // At least one special character
        .required('Password is required'),
})